import { render } from "./ActiveCallName.vue?vue&type=template&id=1162a8e2"
import script from "./ActiveCallName.vue?vue&type=script&lang=js"
export * from "./ActiveCallName.vue?vue&type=script&lang=js"

import "./ActiveCallName.vue?vue&type=style&index=0&id=1162a8e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__